import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import Button from '@/components/Button';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierToStoreTable from '@/modules/admin/components/SupplierToStoreTable';
import { SupplierToStoreAddPath } from '@/modules/admin/paths';
import { LinkIcon } from '@heroicons/react/24/solid';
import { useParams } from 'react-router-dom';

const SupplierToStoreList = () => {
  const { supplierId } = useParams();

  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  const { isLoading, supplier } = useGetSupplierQuery(supplierId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!supplier) {
    return;
  }

  return (
    <div>
      <Breadcrumbs />

      <PageHeader title="Supplier &#128073; Store">
        <Button
          to={SupplierToStoreAddPath.withSupplierId(supplier.id)}
          icon={<LinkIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Link Store
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <SupplierToStoreTable
        supplier={supplier}
        searchQuery={searchQuery}
        page={page}
        onChangePage={handlePageChange}
      />
    </div>
  );
};

export default SupplierToStoreList;
